module.exports = __webpack_public_path__ + "img/getstarted_artwork.64bc811b.png";